import DropDown from '/src/components/UI/DropDown/DropDown';
import TypesMonths from '../../../data/types/TypesMonths';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';

function AnalyticsModalDatePickerCustomDisplay(focusedDate, changeShownDate, props) {
    const { showMonthArrow, locale, minDate, maxDate, showMonthAndYearPickers } = props;
    const upperYearLimit = maxDate.getFullYear();
    const lowerYearLimit = minDate.getFullYear();
    const yearChoices = [...Array(upperYearLimit - lowerYearLimit + 1).keys()].map(year => { return { value : upperYearLimit - year, text : upperYearLimit - year}})

    const upperMonthLimit = maxDate.getMonth();
    const lowerMonthLimit = minDate.getMonth();
    
    const currentMonth = focusedDate.getMonth();
    const currentYear = focusedDate.getFullYear();

    var typesMonthsDropdown = [...TypesMonths];
    
    if(lowerYearLimit == currentYear) {
        typesMonthsDropdown = typesMonthsDropdown.splice(lowerMonthLimit)
    }

    if(upperYearLimit == currentYear) {
        typesMonthsDropdown = typesMonthsDropdown.splice(0, upperMonthLimit + 1)
    }

    return (
        <div style={{ display : 'flex', justifyContent : 'space-between'}}>
            <IconButton className={'main-iconButton profil_action main_add-button space_tableButton '} icon='fas fa-arrow-left' onClick={() => changeShownDate(-1, 'monthOffset')}></IconButton>
                <DropDown choices={typesMonthsDropdown} defaultChoice={currentMonth} name="months" width="190px" hideSelectItem={false} setValue={(name, value) => changeShownDate(value, 'setMonth')}/>
                <DropDown choices={yearChoices} defaultChoice={currentYear} name="years" width="190px" setValue={(name, value) => changeShownDate(value, 'setYear')}/>
            <IconButton className={'main-iconButton profil_action main_add-button space_tableButton '} icon='fas fa-arrow-right' onClick={() => changeShownDate(+1, 'monthOffset')}></IconButton>
        </div>
    )
}

export default AnalyticsModalDatePickerCustomDisplay;